$ = jQuery;

const swiper = new Swiper('.product-slider', {
    slidesPerView: 4,
    spaceBetween: 40,

    breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 40,
        }
    },

    autoplay: {
        delay: 6000,
    },

    loop: true,

    pagination: {
        el: '.swiper-pagination',
    },

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const swiper2 = new Swiper('.big-slider', {
    slidesPerView: 1,
    spaceBetween: 0,

    autoplay: {
        delay: 5000,
    },

    loop: true,

    clickable: true,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },

    pagination: {
        el: '.swiper-pagination',
    },

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const header = new Swiper('.header-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    
    loop: true,

    clickable: true,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },

    pagination: {
        el: '.swiper-pagination-header',
        clickable: true
    },
});

const geraete = [
	{
		name: 'Next',
		className: 'stil-green-text',
		text: 'In der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-green-text" style="font-weight: 400 !important;">Next</span>-Hörwelt finden Sie aktuelle Hörsystemtechnik zu günstigen Einstiegspreisen. Wir helfen Ihnen gern dabei, das für Sie passende Ausstattungspaket Ihren Wünschen entsprechend zu finden.',
		url: '/soniton-hoerwelten/soniton-next/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-eco.png',
		values: {
			technik: 0,
			unauffaellig: 0,
			design: 0,
			flexibel: 0,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 0,
			batterie: 1,
			akku: 0,
			musik: 0,
			konzert: 0,
			gespraeche: 0,
			rad: 0,
			musizieren: 0,
			remote: 0,
			stufen: 0,
			tinnitus: 0
		}
	},
	{
		name: 'Comfort',
		className: 'stil-yellow-text',
		text: 'Hörgeräte der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-yellow-text" style="font-weight: 400 !important;">Comfort</span>-Hörwelt bieten in besonders schwierigen Hörsituationen Hörkomfort und feine Klangdetails. Mit dem passenden Zubehör finden Ihre Hörsysteme zudem Anschluss an die morderne Kommunikations- und Medienwelt.',
		url: '/soniton-hoerwelten/soniton-comfort/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-comfort.png',
		values: {
			technik: 1,
			unauffaellig: 0,
			design: 0,
			flexibel: 0,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 1,
			batterie: 1,
			akku: 1,
			musik: 0,
			konzert: 0,
			gespraeche: 0,
			rad: 0,
			musizieren: 0,
			remote: 1,
			stufen: 0,
			tinnitus: 1
		}
	},
	
	{
		name: 'Next',
		className: 'stil-green-text',
		text: 'Mit einem <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-green-text" style="font-weight: 400 !important;">Next</span>-Hörsystem wählen Sie den umweltbewussten Weg. Geräte aus dieser Hörwelt stehen für eine sichere und umweltschonende Energieversorgung mit Lithium-Ionen-Technologie. Über Nacht oder per Schnellladefunktion in 30 Minuten aufgeladen, sorgt es für mehr Sicherheit und Flexibilität.',
		url: '/soniton-hoerwelten/soniton-next/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-energy.png',
		values: {
			technik: 1,
			unauffaellig: 0,
			design: 0,
			flexibel: 0,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 1,
			batterie: 0,
			akku: 1,
			musik: 0,
			konzert: 0,
			gespraeche: 1,
			rad: 1,
			musizieren: 0,
			remote: 1,
			stufen: 1,
			tinnitus: 1
		}
	},
	{
		name: 'UP',
		className: 'stil-wine-text',
		text: 'Hörgeräte der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-wine-text" style="font-weight: 400 !important;">Up</span>-Hörwelt bereichern mit elegantem Design, hochwertigen Materialien und attraktiven Farben Ihren Alltag. Dank ausgewählter Technik ist dabei ein ausgezeichneter Hörkomfort in jeder Situation gegeben.',
		url: '/soniton-hoerwelten/soniton-up/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-design.png',
		values: {
			technik: 1,
			unauffaellig: 1,
			design: 1,
			flexibel: 0,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 1,
			batterie: 1,
			akku: 1,
			musik: 0,
			konzert: 0,
			gespraeche: 1,
			rad: 1,
			musizieren: 0,
			remote: 1,
			stufen: 0,
			tinnitus: 1
		}
	},
	{
		name: 'Personal',
		className: 'stil-blue-text',
		text: 'Mit einem Hörgerät aus der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-blue-text" style="font-weight: 400 !important;">Personal</span>-Hörwelt können Sie Gespräche mit mehreren Personen wieder meistern. Dank der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;</span>-Technologie verstehen Sie sowohl Ihren Gesprächspartner als auch Stimmen aus anderen Richtungen ohne Probleme.',
		url: '/soniton-hoerwelten/soniton-personal/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-personal.png',
		values: {
			technik: 1,
			unauffaellig: 0,
			design: 0,
			flexibel: 0,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 1,
			batterie: 1,
			akku: 1,
			musik: 1,
			konzert: 1,
			gespraeche: 1,
			rad: 1,
			musizieren: 0,
			remote: 0,
			stufen: 0,
			tinnitus: 0
		}
	},
	{
		name: 'UP',
		className: 'stil-wine-text',
		text: 'Hörsysteme aus der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-wine-text" style="font-weight: 400 !important;">UP</span>-Hörwelt stehen für Flexibilität. Sollten sich  nach dem Kauf Ihre Bedürfnisse oder Ihre Wünsche an die Leistungen Ihrer Hörsysteme ändern, können wir Ihr <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-wine-text" style="font-weight: 400 !important;">UP</span> dank der Flex-Technologie aufrüsten.',
		url: '/soniton-hoerwelten/soniton-up/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-up.png',
		values: {
			technik: 1,
			unauffaellig: 0,
			design: 0,
			flexibel: 1,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 1,
			batterie: 1,
			akku: 1,
			musik: 0,
			konzert: 0,
			gespraeche: 1,
			rad: 1,
			musizieren: 0,
			remote: 1,
			stufen: 1,
			tinnitus: 0
		}
	},
	{
		name: 'Swiss',
		className: 'stil-red-text',
		text: 'Verlässlichkeit und Kompetenz kennzeichnen die Hörsysteme aus der <span style="font-weight: 400 !important;">Soni</span><span style="font-weight: 700 !important;">Ton</span><span style="font-size: 10px !important; font-weight: 400 !important;">&#174;&nbsp;</span><span class="stil-red-text" style="font-weight: 400 !important;">Swiss</span>-Hörwelt. Hier finden Sie modernste Technologie in einer großen Auswahl von Bauformen, Farben, Leistungsklassen und praktischem Wireless Zubehör aus dem Entwicklungszentrum in Bern.',
		url: '/soniton-hoerwelten/soniton-swiss/',
		img: '/wp-content/uploads/2022/08/soniton-configurator-swiss.png',
		values: {
			technik: 1,
			unauffaellig: 0,
			design: 0,
			flexibel: 0,
			komfort: 1,
			smartphone: 1,
			tv: 1,
			multimedia: 1,
			batterie: 1,
			akku: 1,
			musik: 1,
			konzert: 1,
			gespraeche: 1,
			rad: 1,
			musizieren: 1,
			remote: 1,
			stufen: 0,
			tinnitus: 0
		}
	},
]


const result = {
	technik: 0,
	unauffaellig: 0,
	design: 0,
	flexibel: 0,
	komfort: 0,
	smartphone: 0,
	tv: 0,
	multimedia: 0,
	batterie: 0,
	akku: 0,
	musik: 0,
	konzert: 0,
	gespraeche: 0,
	rad: 0,
	musizieren: 0,
	remote: 0,
	stufen: 0,
	tinnitus: 0
}

// compare result with geraete and return the name of the best match
function getBestMatch(result, geraete) {
	let bestMatch = {
		name: '',
		score: 0
	}
	for (let i = 0; i < geraete.length; i++) {
		let score = 0
		for (let key in result) {
			if (result[key] === 1 && geraete[i].values[key] === 1) {
				score++
			}
		}
		if (score > bestMatch.score) {
			bestMatch.name = geraete[i].name
			bestMatch.score = score
		}
	}
	return bestMatch
}

const setResult = (str, el) => { 
	result[str] = el.checked ? 1 : 0
	const productSpan = document.getElementById('result-product')
	const productImg = document.getElementById('result-image')
	const productText = document.getElementById('result-text')
	const productBtn = document.querySelector('[data-producturl]')
	const resultProduct = getBestMatch(result, geraete).name;
	const match = geraete.filter(geraet => geraet.name === resultProduct)[0]
	productSpan.innerHTML = match.name
	productSpan.className = match.className
	productImg.src = match.img
	productText.innerHTML = match.text
	productBtn.href = match.url
	console.log(match)
}

const getResult = (res, element) => res === element

// TABS GLEICH HOCH
var highest_tab = 0;

$('.tabcontent').each(function() {
  if ($(this).height() > highest_tab) {
    highest_tab = $(this).height();
  }
});

$('.tabcontent').each(function() {
  $(this).css('min-height', highest_tab);
  console.log(highest_tab);
});